import e, { createContext as t, useState as r, useEffect as o, useCallback as n, useMemo as c, useContext as a } from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _i = function i() {
  return (_i = Object.assign || function (e) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      for (var n in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function s(e, t, r, o) {
  return new (r || (r = Promise))(function (n, c) {
    function a(e) {
      try {
        s(o.next(e));
      } catch (e) {
        c(e);
      }
    }

    function i(e) {
      try {
        s(o.throw(e));
      } catch (e) {
        c(e);
      }
    }

    function s(e) {
      var t;
      e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(a, i);
    }

    s((o = o.apply(e, t || [])).next());
  });
}

function u(e, t) {
  var r,
      o,
      n,
      c,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & n[0]) throw n[1];
      return n[1];
    },
    trys: [],
    ops: []
  };
  return c = {
    next: i(0),
    throw: i(1),
    return: i(2)
  }, "function" == typeof Symbol && (c[Symbol.iterator] = function () {
    return this;
  }), c;

  function i(c) {
    return function (i) {
      return function (c) {
        if (r) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (r = 1, o && (n = 2 & c[0] ? o.return : c[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, c[1])).done) return n;

            switch (o = 0, n && (c = [2 & c[0], n.value]), c[0]) {
              case 0:
              case 1:
                n = c;
                break;

              case 4:
                return a.label++, {
                  value: c[1],
                  done: !1
                };

              case 5:
                a.label++, o = c[1], c = [0];
                continue;

              case 7:
                c = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(n = a.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                  a = 0;
                  continue;
                }

                if (3 === c[0] && (!n || c[1] > n[0] && c[1] < n[3])) {
                  a.label = c[1];
                  break;
                }

                if (6 === c[0] && a.label < n[1]) {
                  a.label = n[1], n = c;
                  break;
                }

                if (n && a.label < n[2]) {
                  a.label = n[2], a.ops.push(c);
                  break;
                }

                n[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            c = t.call(e, a);
          } catch (e) {
            c = [6, e], o = 0;
          } finally {
            r = n = 0;
          }
        }

        if (5 & c[0]) throw c[1];
        return {
          value: c[0] ? c[1] : void 0,
          done: !0
        };
      }([c, i]);
    };
  }
}

var f,
    l = function l(e) {
  var t = document.querySelector(".grecaptcha-badge");
  t && t.parentNode && document.body.removeChild(t.parentNode);
  var r = document.querySelector("#" + e);
  r && r.remove(), function () {
    var e = document.querySelector("script[src^='https://www.gstatic.com/recaptcha/releases']");
    e && e.remove();
  }();
},
    p = function p(e) {
  var t = e.reCaptchaKey,
      r = e.language,
      o = e.onLoad,
      n = e.useRecaptchaNet,
      c = e.useEnterprise,
      a = e.scriptProps,
      i = void 0 === a ? {} : a,
      s = i.nonce,
      u = void 0 === s ? "" : s,
      f = i.defer,
      l = void 0 !== f && f,
      p = i.async,
      y = void 0 !== p && p,
      d = i.id,
      m = void 0 === d ? "" : d,
      h = i.appendTo,
      v = void 0 === h ? void 0 : h,
      b = m || "google-recaptcha-v3";
  if (function (e) {
    return !!document.querySelector("#" + e);
  }(b)) o();else {
    var S = function (e) {
      return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
    }({
      useEnterprise: c,
      useRecaptchaNet: n
    }),
        g = document.createElement("script");

    g.id = b, g.src = S + "?render=" + t + (r ? "&hl=" + r : ""), u && (g.nonce = u), g.defer = !!l, g.async = !!y, g.onload = o, ("body" === v ? document.body : document.getElementsByTagName("head")[0]).appendChild(g);
  }
},
    y = function y(e) {
  !!process.env && "production" !== process.env.NODE_ENV || console.warn(e);
};

!function (e) {
  e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}(f || (f = {}));
var d = t({
  executeRecaptcha: function executeRecaptcha() {
    throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
  }
}),
    m = d.Consumer;

function h(t) {
  var a = this,
      i = t.reCaptchaKey,
      m = t.useEnterprise,
      h = void 0 !== m && m,
      v = t.useRecaptchaNet,
      b = void 0 !== v && v,
      S = t.scriptProps,
      g = t.language,
      $ = t.children,
      w = r(null),
      P = w[0],
      C = w[1],
      x = JSON.stringify(S);
  o(function () {
    if (i) {
      var e = (null == S ? void 0 : S.id) || "google-recaptcha-v3";
      return p({
        reCaptchaKey: i,
        useEnterprise: h,
        useRecaptchaNet: b,
        scriptProps: S,
        language: g,
        onLoad: function onLoad() {
          if (window && window.grecaptcha) {
            var e = h ? window.grecaptcha.enterprise : window.grecaptcha;
            e.ready(function () {
              C(e);
            });
          } else y("<GoogleRecaptchaProvider /> " + f.SCRIPT_NOT_AVAILABLE);
        },
        onError: function onError() {
          y("Error loading google recaptcha script");
        }
      }), function () {
        l(e);
      };
    }

    y("<GoogleReCaptchaProvider /> recaptcha key not provided");
  }, [h, b, x, g, i]);
  var E = n(function (e) {
    return s(a, void 0, void 0, function () {
      return u(this, function (t) {
        switch (t.label) {
          case 0:
            if (!P || !P.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
            return [4, P.execute(i, {
              action: e
            })];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, [P]),
      R = c(function () {
    return {
      executeRecaptcha: P ? E : void 0
    };
  }, [E, P]);
  return e.createElement(d.Provider, {
    value: R
  }, $);
}

var v = function v() {
  return a(d);
};

function b(e) {
  var t = this,
      r = e.action,
      n = e.onVerify,
      c = v();
  return o(function () {
    var e = c.executeRecaptcha;

    if (e) {
      s(t, void 0, void 0, function () {
        var t;
        return u(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, e(r)];

            case 1:
              return t = o.sent(), n ? (n(t), [2]) : (y("Please define an onVerify function"), [2]);
          }
        });
      });
    }
  }, [r, n, c]), null;
}

function S(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}

var g = "function" == typeof Symbol && Symbol.for,
    $ = g ? Symbol.for("react.element") : 60103,
    w = g ? Symbol.for("react.portal") : 60106,
    P = g ? Symbol.for("react.fragment") : 60107,
    C = g ? Symbol.for("react.strict_mode") : 60108,
    x = g ? Symbol.for("react.profiler") : 60114,
    E = g ? Symbol.for("react.provider") : 60109,
    R = g ? Symbol.for("react.context") : 60110,
    M = g ? Symbol.for("react.async_mode") : 60111,
    N = g ? Symbol.for("react.concurrent_mode") : 60111,
    O = g ? Symbol.for("react.forward_ref") : 60112,
    T = g ? Symbol.for("react.suspense") : 60113,
    _ = g ? Symbol.for("react.suspense_list") : 60120,
    j = g ? Symbol.for("react.memo") : 60115,
    F = g ? Symbol.for("react.lazy") : 60116,
    A = g ? Symbol.for("react.block") : 60121,
    L = g ? Symbol.for("react.fundamental") : 60117,
    k = g ? Symbol.for("react.responder") : 60118,
    V = g ? Symbol.for("react.scope") : 60119;

function G(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case $:
        switch (e = e.type) {
          case M:
          case N:
          case P:
          case x:
          case C:
          case T:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case R:
              case O:
              case F:
              case j:
              case E:
                return e;

              default:
                return t;
            }

        }

      case w:
        return t;
    }
  }
}

function z(e) {
  return G(e) === N;
}

var I = {
  AsyncMode: M,
  ConcurrentMode: N,
  ContextConsumer: R,
  ContextProvider: E,
  Element: $,
  ForwardRef: O,
  Fragment: P,
  Lazy: F,
  Memo: j,
  Portal: w,
  Profiler: x,
  StrictMode: C,
  Suspense: T,
  isAsyncMode: function isAsyncMode(e) {
    return z(e) || G(e) === M;
  },
  isConcurrentMode: z,
  isContextConsumer: function isContextConsumer(e) {
    return G(e) === R;
  },
  isContextProvider: function isContextProvider(e) {
    return G(e) === E;
  },
  isElement: function isElement(e) {
    return "object" == typeof e && null !== e && e.$$typeof === $;
  },
  isForwardRef: function isForwardRef(e) {
    return G(e) === O;
  },
  isFragment: function isFragment(e) {
    return G(e) === P;
  },
  isLazy: function isLazy(e) {
    return G(e) === F;
  },
  isMemo: function isMemo(e) {
    return G(e) === j;
  },
  isPortal: function isPortal(e) {
    return G(e) === w;
  },
  isProfiler: function isProfiler(e) {
    return G(e) === x;
  },
  isStrictMode: function isStrictMode(e) {
    return G(e) === C;
  },
  isSuspense: function isSuspense(e) {
    return G(e) === T;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === P || e === N || e === x || e === C || e === T || e === _ || "object" == typeof e && null !== e && (e.$$typeof === F || e.$$typeof === j || e.$$typeof === E || e.$$typeof === R || e.$$typeof === O || e.$$typeof === L || e.$$typeof === k || e.$$typeof === V || e.$$typeof === A);
  },
  typeOf: G
},
    D = S(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        r = e ? Symbol.for("react.element") : 60103,
        o = e ? Symbol.for("react.portal") : 60106,
        n = e ? Symbol.for("react.fragment") : 60107,
        c = e ? Symbol.for("react.strict_mode") : 60108,
        a = e ? Symbol.for("react.profiler") : 60114,
        i = e ? Symbol.for("react.provider") : 60109,
        s = e ? Symbol.for("react.context") : 60110,
        u = e ? Symbol.for("react.async_mode") : 60111,
        f = e ? Symbol.for("react.concurrent_mode") : 60111,
        l = e ? Symbol.for("react.forward_ref") : 60112,
        p = e ? Symbol.for("react.suspense") : 60113,
        y = e ? Symbol.for("react.suspense_list") : 60120,
        d = e ? Symbol.for("react.memo") : 60115,
        m = e ? Symbol.for("react.lazy") : 60116,
        h = e ? Symbol.for("react.block") : 60121,
        v = e ? Symbol.for("react.fundamental") : 60117,
        b = e ? Symbol.for("react.responder") : 60118,
        S = e ? Symbol.for("react.scope") : 60119;

    function g(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case r:
            var y = e.type;

            switch (y) {
              case u:
              case f:
              case n:
              case a:
              case c:
              case p:
                return y;

              default:
                var h = y && y.$$typeof;

                switch (h) {
                  case s:
                  case l:
                  case m:
                  case d:
                  case i:
                    return h;

                  default:
                    return t;
                }

            }

          case o:
            return t;
        }
      }
    }

    var $ = u,
        w = f,
        P = s,
        C = i,
        x = r,
        E = l,
        R = n,
        M = m,
        N = d,
        O = o,
        T = a,
        _ = c,
        j = p,
        F = !1;

    function A(e) {
      return g(e) === f;
    }

    t.AsyncMode = $, t.ConcurrentMode = w, t.ContextConsumer = P, t.ContextProvider = C, t.Element = x, t.ForwardRef = E, t.Fragment = R, t.Lazy = M, t.Memo = N, t.Portal = O, t.Profiler = T, t.StrictMode = _, t.Suspense = j, t.isAsyncMode = function (e) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(e) || g(e) === u;
    }, t.isConcurrentMode = A, t.isContextConsumer = function (e) {
      return g(e) === s;
    }, t.isContextProvider = function (e) {
      return g(e) === i;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, t.isForwardRef = function (e) {
      return g(e) === l;
    }, t.isFragment = function (e) {
      return g(e) === n;
    }, t.isLazy = function (e) {
      return g(e) === m;
    }, t.isMemo = function (e) {
      return g(e) === d;
    }, t.isPortal = function (e) {
      return g(e) === o;
    }, t.isProfiler = function (e) {
      return g(e) === a;
    }, t.isStrictMode = function (e) {
      return g(e) === c;
    }, t.isSuspense = function (e) {
      return g(e) === p;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === n || e === f || e === a || e === c || e === p || e === y || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === d || e.$$typeof === i || e.$$typeof === s || e.$$typeof === l || e.$$typeof === v || e.$$typeof === b || e.$$typeof === S || e.$$typeof === h);
    }, t.typeOf = g;
  }();
}),
    q = (D.AsyncMode, D.ConcurrentMode, D.ContextConsumer, D.ContextProvider, D.Element, D.ForwardRef, D.Fragment, D.Lazy, D.Memo, D.Portal, D.Profiler, D.StrictMode, D.Suspense, D.isAsyncMode, D.isConcurrentMode, D.isContextConsumer, D.isContextProvider, D.isElement, D.isForwardRef, D.isFragment, D.isLazy, D.isMemo, D.isPortal, D.isProfiler, D.isStrictMode, D.isSuspense, D.isValidElementType, D.typeOf, S(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = I : e.exports = D;
})),
    B = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
},
    K = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
},
    J = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
},
    U = {};

function H(e) {
  return q.isMemo(e) ? J : U[e.$$typeof] || B;
}

U[q.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, U[q.Memo] = J;
var Q = Object.defineProperty,
    W = Object.getOwnPropertyNames,
    X = Object.getOwnPropertySymbols,
    Y = Object.getOwnPropertyDescriptor,
    Z = Object.getPrototypeOf,
    ee = Object.prototype;

var te = function e(t, r, o) {
  if ("string" != typeof r) {
    if (ee) {
      var n = Z(r);
      n && n !== ee && e(t, n, o);
    }

    var c = W(r);
    X && (c = c.concat(X(r)));

    for (var a = H(t), i = H(r), s = 0; s < c.length; ++s) {
      var u = c[s];

      if (!(K[u] || o && o[u] || i && i[u] || a && a[u])) {
        var f = Y(r, u);

        try {
          Q(t, u, f);
        } catch (e) {}
      }
    }
  }

  return t;
},
    re = function re(t) {
  var r = function r(_r) {
    return e.createElement(m, null, function (o) {
      return e.createElement(t, _i({}, _r, {
        googleReCaptchaProps: o
      }));
    });
  };

  return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", te(r, t), r;
};

export { b as GoogleReCaptcha, m as GoogleReCaptchaConsumer, d as GoogleReCaptchaContext, h as GoogleReCaptchaProvider, v as useGoogleReCaptcha, re as withGoogleReCaptcha };